import { useEffect, useState } from 'react';
import { Grid, Stack, Paper, Typography, Card, Button, TextField, FormControl, InputLabel, Select, MenuItem, Autocomplete } from '@mui/material'
import { useThemeContext } from 'app/ThemeProvider';
import EvStationIcon from '@mui/icons-material/EvStation';
import BoltIcon from '@mui/icons-material/Bolt';
import EnergyChart from 'app/views/charger/shared/charger-detail/EnergyChart';
import ChargingPortChart from 'app/views/charger/shared/charger-detail/ChargingPowerGraph';
import SocChart from 'app/views/charger/shared/charger-detail/SocChart';
import TempChart from 'app/views/charger/shared/charger-detail/TempChart';
import VoltageChart from 'app/views/charger/shared/charger-detail/Voltagechart';
import Currentchart from 'app/views/charger/shared/charger-detail/CurrentChart';
import ChargerApi from 'app/views/charger/ChargerApi';
import ReportApi from '../ReportApi';
import Loading from 'app/components/MatxLoading';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { ExportToExcel2 } from './ExportToExcel';
import VehicleApi from 'app/views/cmsmgmt/vechilemgmt/VehicleApi';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

const TransactionAnalytics = ({ receivedTransactionPk = null, options = true }) => {

  const { darkTheme } = useThemeContext();
  const [value, setvalue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [transactionPk, setTransactionPk] = useState("");
  const [transactionLogData, setTransactionLogData] = useState([]);
  const chargerApi = new ChargerApi();
  const api = new ReportApi();

  const [connectorList, setConnectorList] = useState(new Set());
  const [data, setReportData] = useState([]);
  const [selectedConnector, setSelectedConnector] = useState(1);
  const timezone = localStorage.getItem("orgTimezone");
  const [chargerId, setChargerId] = useState("");
  const [vehicleLicensePlate, setVehicleLicensePlate] = useState("");
  const [chargerList, setChargerList] = useState([]);
  const [selectedChargeBoxId, setSelectedChargeBoxId] = useState("");
  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const vehicleApi = new VehicleApi();

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [transactionList, setTransactionList] = useState([]);

  const [params, setParams] = useState({});


  function handleChange(e) {

    console.log(e);

    setParams({ ...params, [e.target.name]: e.target.value })
  }

  // function handleChange(e, value) {
  //   setParams({ ...params, [e.target.name]: value })
  // }




  useEffect(() => {
    fetchChargerList();
    fetchVehicleList();
  }, []);


  useEffect(() => {

    setTransactionList([])
    // setTransactionPk("");
    fetchTransactionStartList(null);
  }, [params]);

  // useEffect(()=>{


  // },[transactionPk]);



  const fetchTransactionStartList = (transactionPk) => {

    // const params = { chargeBoxId: selectedChargeBoxId, vehicleLicensePlate: selectedVehicle }

    // if (transactionPk)
    //   params.transactionPk = transactionPk;

    api
      .getTransactionList(params)
      .then((response) => {
        // console.log(response.data);
        setTransactionList(response.data.data);
        // setSelectedChargerList(response.data.map(c => c.chargeBoxId))
      })
      .catch((e) => {
        console.log('Cannot load event data', e);
      })

  }


  const fetchChargerList = () => {

    const selectDepotId = localStorage.getItem("selected_depot");

    chargerApi
      .getChargerListByDepotId({ depotIdList: selectDepotId })
      .then((response) => {
        // console.log(response.data);
        setChargerList(response.data);
        // setSelectedChargerList(response.data.map(c => c.chargeBoxId))
      })
      .catch((e) => {
        console.log('Cannot load event data', e);
      });

  };

  const fetchVehicleList = () => {

    setVehicleList([]);
    const selectDepotId = localStorage.getItem("selected_depot");


    vehicleApi
      .getVehicleList(null, selectDepotId)
      .then((response) => {

        // console.log( response.data)
        setVehicleList(response.data);
        console.log(response.data);
        // setSelectedVehicleList(response.data.map(v => v.id))

        setLoading(false)
      })
      .catch((e) => {
        // console.log('Cannot load event data', e);
      });
  };


  const fetchTransactionLog = () => {

    console.log(params);

    setLoading(true)

    chargerApi.getTransactionLog({ transactionPk: params.transactionPk })
      .then(({ data }) => {
        // console.log(data);



        setTransactionLogData(data);
        if (Array.isArray(data)) {

          const arr = []

          if (data.filter(o => o.connector_id == 2).length > 0) {
            arr.push(2)
            setSelectedConnector(2);
          }
          if (data.filter(o => o.connector_id == 1).length > 0) {
            arr.push(1)
            setSelectedConnector(1);
          }
          if (data.length > 0) {
            setChargerId(data[0].charge_box_id);
            setVehicleLicensePlate(data[0].vehicle_license_plate);
            setTransactionPk(data[0].transaction_pk);
          }

          setConnectorList(arr);




        }
        setLoading(false);
      })
      .catch((e) => {
        console.log('Request history data', e);
      });

  }

  const fetchTransactionRawLog = () => {

    chargerApi.getTransactionRawLog({ transactionPk: transactionPk })
      .then(({ data }) => {
        // console.log(data);

        if (data.length > 0) {

          // const blob = new Blob([data], { type: 'text/plain' });
          // const link = document.createElement('a');
          // // Set the URL for the Blob as the href attribute of the link
          // link.href = URL.createObjectURL(blob);
          // // Set the download attribute with the desired filename
          // link.download = transactionPk + "log_file_"
          //   + "_on_" + new Date().toLocaleString();
          // // Append the link to the document body
          // document.body.appendChild(link);
          // // Programmatically click the link to trigger the download
          // link.click();
          // // Remove the link from the document
          // document.body.removeChild(link);

          const columns = [

            {
              field: "date",
              headerName: "Date"
            },
            {
              field: "time",
              headerName: "Time"
            },
            {
              field: "chargeBoxId",
              headerName: "Charger ID"
            },
            {
              field: "direction",
              headerName: "Type"
            },
            {
              field: "requestType",
              headerName: "Request"
            },
            {
              field: "payload",
              headerName: "Message"
            },

          ]


          ExportToExcel2({
            data: data
            , columns: columns
            , fileName: transactionPk + "log_file_" + "_on_" + new Date().toLocaleString()

          });





        } else window.alert("Data Not Found.")

      })
      .catch((e) => {
        toast.error("Failed:", e)
        console.log('Request history data', e);

      });
  }

  const fetchTransactionLog2 = (transactionPk) => {
    setLoading(true)

    chargerApi.getTransactionLog({ transactionPk: transactionPk })
      .then(({ data }) => {
        // console.log(data);
        setTransactionLogData(data);
        if (Array.isArray(data)) {

          const arr = []

          if (data.filter(o => o.connector_id == 2).length > 0) {
            arr.push(2)
            setSelectedConnector(2);
          }
          if (data.filter(o => o.connector_id == 1).length > 0) {
            arr.push(1)
            setSelectedConnector(1);
          }
          if (data.length > 0) {
            setChargerId(data[0].charge_box_id);
            setVehicleLicensePlate(data[0].vehicle_license_plate);
          }

          setConnectorList(arr);

        }
        setLoading(false);
      })
      .catch((e) => {
        console.log('Request history data', e);
      });

  }

  useEffect(() => {
    if (receivedTransactionPk === null)
      getChargingMonitorReport();
    else {
      setTransactionPk(receivedTransactionPk)
      fetchTransactionLog2(receivedTransactionPk)
    }
  }, [receivedTransactionPk]);


  const getChargingMonitorReport = () => {
    let isCanceled = false;
    setLoading(true)
    // console.log(params);
    api
      .showChargerStMonitorReport({})
      .then(({ data }) => {
        if (!isCanceled) {
          console.log(data)

          const arr = data.filter(o => parseFloat(o.energy) > 0);
          if (arr.length > 0) {
            setTransactionPk(arr[0].transaction_pk);
            fetchTransactionLog2(arr[0].transaction_pk);

          }

          setReportData(data);
          // if (data.length === 0)
          // alert("Data Not Found")
          setLoading(false);

        }
      })
      .catch((e) => {
        console.log('Cannot load report data', e);
      }).finally(() => { setLoading(false); });

  };




  const backgroundColorSelected = darkTheme ? '#F2E34C' : 'black'; // Background color of selected tab
  const backgroundColorUnselected = darkTheme ? '#334155' : '#d9d9d9';
  const textColorSelected = darkTheme ? 'black' : 'white'; // Text color of selected tab
  const textColorUnselected = darkTheme ? 'white' : 'black';

  const handleConnectorChange = (val) => {
    setLoading(true);
    setSelectedConnector(val);

    setTimeout(() => {
      setLoading(false);
    }, 200);


  }

  function getNoonUtcEpoch(d: Dayjs) {
    // Safe (no plugins needed): build a UTC timestamp for 12:00
    return Date.UTC(d.year(), d.month(), d.date(), 12, 0, 0, 0);
  }


  return (
    <Grid  >

      <Paper style={{ minHeight: '70vh', maxHeight: '120vh', backgroundColor: darkTheme ? '#333333' : '#f9f9f9' }} elevation={2}>

        <Stack>

          <Grid container spacing={1} padding={"5px"} >
            <Grid item md={.5} padding={"10px"}>
              {/* <Typography variant="h6" style={{ color: darkTheme ? '#fff' : '#000' }}>
                Transaction </Typography> */}

            </Grid>


            <Grid item xs={2.5} sm={2.5} md={3} lg={1.5} xl={1.5}>

              {
                options &&
                <FormControl fullWidth >
                  <Autocomplete
                    disablePortal
                    variant='standard'
                    name='vehicleLicensePlate'
                    // onChange={(e, value) => handleChange(e)}
                    onInputChange={(e, newInputValue) => handleChange({ target: { name: 'vehicleLicensePlate', value: newInputValue } })}

                    options={[
                      { label: "", id: "" }, // Add "All" option
                      ...vehicleList.map(vehicle => ({
                        label: vehicle.vehicleLicensePlate, // Display License Plate
                        id: vehicle.id // Store ID in state
                      }))
                    ]}
                    // sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} variant='standard' name='vehicleLicensePlate'
                      label="Vehicle License Plate" />}
                  />
                </FormControl>
              }



            </Grid>


            <Grid item xs={2.5} sm={2.5} md={3} lg={1} xl={1}>

              {
                options &&
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label2">Charger ID</InputLabel>
                  <Select
                    labelId="demo-simple-select-label2"
                    id="demo-simple-select2"
                    value={params.chargeBoxId}
                    variant='standard'
                    // multiple
                    name='chargeBoxId'
                    onChange={handleChange}
                    label="Charger ID"
                  >
                    <MenuItem value={""}>All</MenuItem>
                    {
                      chargerList.map(charger =>
                        <MenuItem value={charger.chargeBoxId}>{charger.chargeBoxId}</MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              }

            </Grid>

            <Grid item xs={2.5} sm={2.5} md={3} lg={1} xl={1}>

              {
                options &&

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3} sx={{ maxWidth: 420 }}>
                    <DatePicker
                      label="From"
                      name='from'
                      // value={fromDate}
                      onChange={(newValue) => {
                        setParams((prev) => ({
                          ...prev,
                          from: newValue ? getNoonUtcEpoch(newValue) : null,  // <-- 12:00 UTC epoch
                        }));
                      }}
                      disableFuture
                      // minDate={dayjs().subtract(1, 'year')}
                      format="DD/MM/YYYY"                    // display format
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: 'standard',
                          helperText: fromDate ? fromDate.format('YYYY-MM-DD') : '',
                        },
                      }}
                    />
                  </Stack>
                </LocalizationProvider>
              }

            </Grid>


            <Grid item xs={2.5} sm={2.5} md={3} lg={1} xl={1}>

              {
                options &&

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3} sx={{ maxWidth: 420 }}>
                    <DatePicker
                      label="To"
                      name='to'
                      value={toDate}
                      onChange={(newValue) => {
                        setParams((prev) => ({
                          ...prev,
                          to: newValue ? getNoonUtcEpoch(newValue) : null,  // <-- 12:00 UTC epoch
                        }));
                      }}
                      disableFuture
                      // minDate={dayjs().subtract(1, 'year')}
                      format="DD/MM/YYYY"                    // display format
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: 'standard',
                          helperText: toDate ? toDate.format('YYYY-MM-DD') : '',
                        },
                      }}
                    />
                  </Stack>
                </LocalizationProvider>
              }
            </Grid>









            <Grid item xs={2.5} sm={2.5} md={3} lg={1} xl={1} >


              {/* <TextField
                style={{ paddingTop: '16px' }}
                variant='standard'
                value={transactionPk}
                name='transactionPk'
                onChange={(e) => setTransactionPk(e.target.value)}
                disabled={!enableLogDownload}

              /> */}

              {
                options &&
                <FormControl fullWidth >
                  <Autocomplete
                    freeSolo
                    disablePortal
                    variant='standard'
                    name='transactionPk'
                    // onChange={(e, value) => setTransactionPk(value ? value.id : "")}

                    onInputChange={(e, newInputValue) => handleChange({ target: { name: 'transactionPk', value: newInputValue } })}

                    options={
                      // { label: "All", id: "0" }, // Add "All" option
                      transactionList.map(transactionStart => ({
                        label: transactionStart.transactionPk, // Display License Plate
                        id: transactionStart.transactionPk // Store ID in state
                      }))
                    }
                    // sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} name='transactionPk' variant='standard'
                      label="Transaction ID" />}
                  />
                </FormControl>
              }


              &nbsp;&nbsp;




            </Grid>


            <Grid item md={3} >


              {
                options && (

                  <>

                    <Button

                      style={{
                        border: '2px solid green', backgroundColor: 'white', margin: 0,
                        color: 'green', fontSize: '15px', fontWeight: 'bold', borderRadius: '25px',
                        padding: "3px 10px",
                      }}
                      color='primary'
                      variant='contained'
                      onClick={fetchTransactionLog}>
                      Analyze
                    </Button>
                    &nbsp;&nbsp;


                    <Button
                      style={{
                        border: '2px solid blue', backgroundColor: 'white', margin: 0,
                        color: 'blue', fontSize: '15px', fontWeight: 'bold', borderRadius: '25px',
                        padding: "3px 10px",
                      }}
                      color='primary'
                      variant='contained'
                      onClick={fetchTransactionRawLog}>
                      Log Download
                    </Button>
                  </>
                )
              }

            </Grid>






            <Grid item md={3} padding={"10px"}>

              {
                Array.from(connectorList).sort((a, b) => a - b).map(connector => {

                  return <Button variant="contained"

                    // disabled={value === 2}
                    style={{
                      backgroundColor: connector === selectedConnector ? backgroundColorSelected : backgroundColorUnselected,
                      color: connector === selectedConnector ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0"
                    }}
                    onClick={() => handleConnectorChange(connector)}>Connector {connector} </Button>

                })
              }

            </Grid>




          </Grid>
        </Stack>

        <Stack spacing={2} direction="row" padding={'15px'} overflow={'auto'}>
          <Button variant="contained"

            disabled={value === 0}
            style={{
              backgroundColor: value === 0 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 0 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "5px 0 0 5px"
              , minWidth: 150
            }}
            onClick={() => { setvalue(0) }}>Charging Power</Button>

          <Button variant="contained"
            disabled={value === 1}
            style={{
              backgroundColor: value === 1 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 1 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0"
              , minWidth: 100

            }}

            onClick={() => { setvalue(1) }}>Energy</Button>
          <Button variant="contained"

            disabled={value === 2}
            style={{
              backgroundColor: value === 2 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 2 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0"

            }}
            onClick={() => { setvalue(2) }}>SoC</Button>

          <Button variant="contained"
            disabled={value === 3}
            style={{
              backgroundColor: value === 3 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 3 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0"
              , minWidth: 120

            }}
            onClick={() => { setvalue(3) }}>Temperature</Button>

          <Button variant="contained"
            disabled={value === 4}
            style={{
              backgroundColor: value === 4 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 4 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0", boxShadow: 0
              , minWidth: 100

            }}
            onClick={() => { setvalue(4) }}>Voltage</Button>

          <Button variant="contained"
            disabled={value === 5}
            style={{
              backgroundColor: value === 5 ? backgroundColorSelected : backgroundColorUnselected,
              color: value === 5 ? textColorSelected : textColorUnselected, margin: 0, borderRadius: "0 5px  5px 0"
              , minWidth: 100

            }}
            onClick={() => { setvalue(5) }}>Current</Button>




        </Stack>



        <Grid textAlign='left' padding={'15px'}>
          <div style={{ padding: '2px', display: 'inline-block', margin: '5px', maxHeight: '50px', backgroundColor: backgroundColorUnselected, borderRadius: '10px' }}>
            <Typography style={{ color: darkTheme ? '#F2E34C' : '#000' }}>
              <span style={{ borderRadius: '10px', padding: '2px', display: 'inline-block', margin: '5px', fontSize: '16px' }}>
                Date: {transactionLogData.length && (
                  <span style={{ padding: '5px', display: 'inline-block', margin: '5px' }}>
                    {/* {new Date(transactionLogData[0].value_timestamp).toDateString()} */}
                    {DateTime.fromISO(transactionLogData[0].value_timestamp).setZone(timezone).toFormat('dd-MM-yyyy')}
                  </span>
                )}
              </span>
              <span style={{ padding: '2px', borderRadius: '10px', display: 'inline-block', margin: '5px', fontSize: '16px' }}>
                Duration: {transactionLogData.length && (
                  <span style={{ padding: '2px', display: 'inline-block', margin: '5px' }}>
                    {/* {((new Date(transactionLogData[transactionLogData.length - 1].value_timestamp).getTime()
                                            - new Date(transactionLogData[0].value_timestamp).getTime()) / 60000).toFixed(2)} Mins */}
                    {((DateTime.fromISO(transactionLogData[transactionLogData.length - 1].value_timestamp).setZone(timezone).toMillis()
                      - DateTime.fromISO(transactionLogData[0].value_timestamp).setZone(timezone).toMillis()) / 60000).toFixed(2)} Mins
                  </span>
                )}
              </span>
              <span style={{ padding: '2px', borderRadius: '10px', display: 'inline-block', margin: '5px', fontSize: '16px' }}>
                Transaction ID: <span style={{ padding: '2px', display: 'inline-block', margin: '5px' }}>{transactionPk}</span>
              </span>
              <span style={{ padding: '2px', borderRadius: '10px', display: 'inline-block', margin: '5px', fontSize: '16px' }}>
                Charger ID: <span style={{ padding: '2px', display: 'inline-block', margin: '5px' }}>{chargerId}</span>
              </span>
              <span style={{ padding: '2px', borderRadius: '10px', display: 'inline-block', margin: '5px', fontSize: '16px' }}>
                Vehicle License Plate: <span style={{ padding: '2px', display: 'inline-block', margin: '5px' }}>{vehicleLicensePlate}</span>
              </span>
            </Typography>
          </div>
        </Grid>



        <Grid width={'100%'} overflow={'auto'}>

          <Grid minWidth={'50rem'}>


            {
              loading ? <div style={{ height: '300px' }}>
                <Loading />
              </div> :

                <>


                  {value === 0 ? (<ChargingPortChart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj => (obj.unit === "W" || obj.unit === "kW")
                      && obj.connector_id === selectedConnector

                    )} />) : null}

                  {value === 1 ? (<EnergyChart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj.measurand === "Energy.Active.Import.Register"
                      && obj.connector_id === selectedConnector

                    )}
                  />) : null}

                  {value === 2 ? (<SocChart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj.measurand === "SoC"
                      && obj.connector_id === selectedConnector

                    )}
                  />) : null}

                  {value === 3 ? (<TempChart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj.measurand === "Temperature"
                      && obj.connector_id === selectedConnector

                    )}
                  />) : null}

                  {value === 4 ? (<VoltageChart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj.measurand === "Voltage"
                      && obj.connector_id === selectedConnector

                    )}
                  />) : null}

                  {value === 5 ? (<Currentchart darkTheme={darkTheme}
                    data={transactionLogData.filter(obj => obj.unit === "A"
                      && obj.connector_id === selectedConnector

                    )}
                  />) : null}

                </>
            }

          </Grid>
        </Grid>

      </Paper>

    </Grid>
  );

}

export default TransactionAnalytics;